// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { SETTINGS } from "./settings";
import * as npm from "../../package.json";

export const environment = {
  production: false,
  appSettings: SETTINGS,
  googleMapApiKey: "AIzaSyBSvo0x8v3C6aFWcSi2zooOC9tqGCOqCj4",
  version: npm.version,
  // serverUrl: 'https://test.iglulabs.com/rentsher/public/index.php/',
  // https://stagingrestaurant.foodbud.app/#/horizontal/main


  // MAIN URL 

  serverUrl: "https://stagingapi.foodbud.app/api/auth/",
  loginUrl: "https://stagingapi.foodbud.app/api/auth/",
  baseUrl: "https://stagingapi.foodbud.app/restaurant/V1/",
  sharelinkUrlFb: "https://www.facebook.com/sharer/sharer.php?u=",
  sharelinkUrlwhatapp: "https://wa.me/?text=",
  sharelinkUrltwitter: "https://twitter.com/intent/tweet?text=",
  superAdminUrl: "https://stagingapi.foodbud.app/super_admin/V1/",
  categoryAndCuisineUrl: "https://stagingapi.foodbud.app/api/Guest/",
  superAdminLoginUrl: "https://stagingapi.foodbud.app/index.php/api/auth/",
  superAdminPasswordUrl:'https://stagingapi.foodbud.app/api/Auth/',
  d2RestoUrl:'https://stagingapi.foodbud.app/new_restaurant/V1/',
  claimResto:'https://stagingapi.foodbud.app/claim_restaurant/V1/',
  nutriLabel:'https://stagingapi.foodbud.app/recipe_nutrition/V1/',
  mainBaseUrl: 'https://stagingapi.foodbud.app/',







// LOCAL URL 
  // serverUrl: "http://localhost:8000/api/auth/",
  // loginUrl: "http://localhost:8000/api/auth/",
  // baseUrl: "http://localhost:8000/restaurant/V1/",
  // sharelinkUrlFb: "https://www.facebook.com/sharer/sharer.php?u=",
  // sharelinkUrlwhatapp: "https://wa.me/?text=",
  // sharelinkUrltwitter: "https://twitter.com/intent/tweet?text=",
  // superAdminUrl: "http://localhost:8000/super_admin/V1/",
  // categoryAndCuisineUrl: "http://localhost:8000/api/Guest/",
  // superAdminLoginUrl: "http://localhost:8000/index.php/api/auth/",
  // superAdminPasswordUrl:'http://localhost:8000/api/Auth/',
  // d2RestoUrl:'http://localhost:8000/new_restaurant/V1/',
  // claimResto:'http://localhost:8000/claim_restaurant/V1/',
  // nutriLabel:'http://localhost:8000/recipe_nutrition/V1/',
  // mainBaseUrl: 'http://localhost:8000/'
};
